import { OnInit, Component, inject, signal, input, computed } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, RouterLink } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

export interface Breadcrumb {
  label: string;
  url: string;
}
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [CommonModule, RouterLink],
  standalone: true
})
export class BreadcrumbComponent  implements OnInit {
  data = input<Breadcrumb[]>([]);
  // constructor() { }

  ngOnInit() {}

  // Internal router-derived state
  private routerBreadcrumbs = signal<Breadcrumb[]>([]);

  // Computed state: prefer manual input if present, otherwise use router logic
  activeBreadcrumbs = computed(() => {
    const manual = this.data();
    return manual && manual.length > 0 ? manual : this.routerBreadcrumbs();
  });

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(null)
    ).subscribe(() => {
      this.routerBreadcrumbs.set(this.buildBreadcrumbs(this.activatedRoute.root));
    });
  }

  private buildBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
        
        // Support parent definition from route data
        if (child.snapshot.data['parent']) {
            const p = child.snapshot.data['parent'];
            breadcrumbs.push({ label: p.label, url: p.url });
        }

        let label = 'Detail';
        if (child.snapshot.data['breadcrumb']) {
             label = child.snapshot.data['breadcrumb'];
        } else {
             const lastSegment = child.snapshot.url[child.snapshot.url.length - 1].path;
             if (!lastSegment.match(/^[0-9a-fA-F-]+$/)) {
                 label = lastSegment.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
             }
        }
        
        if (url !== '/dashboard') {
             breadcrumbs.push({ label, url });
        }
      }
      return this.buildBreadcrumbs(child, url, breadcrumbs);
    }
    return breadcrumbs;
  }
}
